<template>
    <div class="container-fluid my-3 py-3">
        <div class="row my-3">
            <div class="col-12">
                <div class="form-floating">
                    <input id="inputName" ref="name" type="text" name="name" class="form-control"  v-model="organisationDailyReportHeader.name" placeholder="name@example.com">
                    <label for="inputName" class="form-label" >{{ $t("name") }}</label>
                </div>
            </div>                
        </div>
        <div class="row my-3">
            <div class="col-6">
                <div class="form-check form-switch">
                    <input class="form-check-input" id="show_installed_capacity" type="checkbox" v-model="organisationDailyReportHeader.show_installed_capacity">
                    <label class="form-check-label" for="show_installed_capacity" >
                        {{ $t("show_installed_capacity")}}
                    </label>
                </div>
            </div>
            <div class="col-6" v-if="organisationDailyReportHeader.show_installed_capacity">
                <div class="form-floating">
                    <input id="inputName" ref="name" type="text" name="name" class="form-control"  v-model="organisationDailyReportHeader.linked_plant" placeholder="name@example.com">
                    <label for="inputName" class="form-label" >{{ $t("linked_plant") }}</label>
                </div>
            </div>
        </div>
        <div class="row my-3">
            <div class="col-6">
                <div class="form-check form-switch">
                    <input class="form-check-input" id="page_break_after_pdf" type="checkbox" v-model="organisationDailyReportHeader.page_break_after_pdf">
                    <label class="form-check-label" for="page_break_after_pdf" >
                        {{ $t("page_break_afterwards")}}
                    </label>
                </div>
            </div>
        </div>
        <div class="row my-3">
            <div class="col-6">
                <div class="form-check form-switch">
                    <input class="form-check-input" id="hide_frontend" type="checkbox" v-model="organisationDailyReportHeader.hide_subheaders_frontend">
                    <label class="form-check-label" for="hide_frontend" >
                        {{ $t("subheader_hide_frontend")}}
                    </label>
                </div>
            </div>  
        </div>
        <button class="btn btn-success mb-0 ms-auto" @click="submitForm">{{ $t("save") }}</button>
    </div>
</template>

<script>
import { createToast } from '@/assets/js/myToast.js'
import axios from 'axios'
export default {
    name: 'EditOrganisationDailyReportHeader',
    emits: ['closeModal'],
    props: {
        organisationDailyReportHeader: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            
        }
    },
    mounted(){
        console.log('entry mounted')
        this.focusInput()
        console.log('exit mounted')
    },
    methods: {
        focusInput() {
            console.log('entry focusInput')
            console.log(this.$refs.name)
            this.$refs.name.focus();
            console.log('exit focusInput')
        },
        submitForm() {
            
            axios
                .patch(`/api/v1/organisation_daily_report_headers/${this.organisationDailyReportHeader.id}/`, this.organisationDailyReportHeader)
                .then(response => {
        
                    createToast({text: this.$t("header altered")
                        ,type: 'success'})

                this.$emit('closeModal')
                })
                .catch(error => {
                    if (error.response) {
                        if ('detail' in error.response.data){
                            createToast({text: this.$t(error.response.data['detail'])
                                        ,type: 'error'})
                        }                        
                        console.error(JSON.stringify(error.response.data))
                    } else if (error.message) {
                        console.error(JSON.stringify(error.message))
                    } else {
                        console.error(JSON.stringify(error))
                    }
                })
        }
    },
    computed:{
    }
}
</script>